import { AppLayout } from '../components/AppLayout';
import { UserRoute } from '../components/ProtectedRoute';

// Access control is handled inside quantum.tsx (email check for ryand32@gmail.com).
// UserRoute ensures the user is authenticated; the component gates on email.
export default [UserRoute, AppLayout];
